import * as React from 'react'
import { LabelledOutline } from '../LabelledOutline'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

import * as styles from './MultipleCheckbox.module.scss'

export const MultipleCheckbox = ({
  name,
  label,
  options,
  register,
  saveAsJsonOnProfile,
  onlyOneOptionPossible,
  setFieldValue,
  getValues,
  jsonFieldOnForm = 'extraFieldJson',
}) => {
  const [selectedOptions, setSelectedOptions] = React.useState(
    Array.isArray(options) ? [] : '',
  )

  const previousDataSaved = getValues(jsonFieldOnForm)

  const handleOptionChange = event => {
    const { value } = event.target
    if (onlyOneOptionPossible) {
      if (saveAsJsonOnProfile) {
        const newJson = {
          ...previousDataSaved,
          [name]: value,
        }
        setFieldValue(jsonFieldOnForm, newJson)
      }
      setSelectedOptions([value])
    } else {
      if (selectedOptions.includes(value)) {
        setSelectedOptions(selectedOptions.filter(option => option !== value))
        if (saveAsJsonOnProfile) {
          const newJson = {
            ...previousDataSaved,
            [name]: selectedOptions.filter(option => option !== value),
          }
          setFieldValue(jsonFieldOnForm, newJson)
        }
      } else {
        if (saveAsJsonOnProfile) {
          const newJson = {
            ...previousDataSaved,
            [name]: [...selectedOptions, value],
          }
          setFieldValue(jsonFieldOnForm, newJson)
        }
        setSelectedOptions([...selectedOptions, value])
      }
    }
  }

  return (
    <LabelledOutline label={label}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          rowGap: '14px',
        }}
      >
        {options.map(option => {
          return onlyOneOptionPossible ? (
            <FormControlLabel
              sx={{
                marginRight: '0',
              }}
              classes={{
                root: styles.labelCheckboxClass,
              }}
              slotProps={{
                typography: {
                  sx: {
                    fontSize: '0.75rem',
                  },
                },
              }}
              key={option}
              control={
                <Checkbox
                  {...register(name)}
                  size="medium"
                  classes={{
                    root: styles.checkboxClass,
                  }}
                  checked={selectedOptions[0] === option}
                  onChange={handleOptionChange}
                  value={option}
                  name={name}
                />
              }
              label={option}
            />
          ) : (
            <FormControlLabel
              sx={{
                padding: '0',
              }}
              key={option}
              classes={{
                root: styles.labelCheckboxClass,
              }}
              slotProps={{
                typography: {
                  sx: {
                    fontSize: '0.75rem',
                  },
                },
              }}
              control={
                <Checkbox
                  {...register(name)}
                  size="medium"
                  classes={{
                    root: styles.checkboxClass,
                    checked: styles.checked,
                  }}
                  checked={selectedOptions.includes(option)}
                  onChange={handleOptionChange}
                  value={option}
                  name={name}
                />
              }
              label={option}
            />
          )
        })}
      </div>
    </LabelledOutline>
  )
}
